export const PaginationControls = ({
  currentPage,
  lastPage,
  onPageChange,
  isEnroll = false,
}) => {
  const getVisiblePages = () => {
    const delta = 2
    const pages = []

    pages.push(1)

    const start = Math.max(2, currentPage - delta)
    const end = Math.min(lastPage - 1, currentPage + delta)

    if (start > 2) pages.push("...")

    for (let i = start; i <= end; i++) pages.push(i)

    if (end < lastPage - 1) pages.push("...")

    if (lastPage > 1) pages.push(lastPage)

    return [...new Set(pages)]
  }

  return (
    <nav>
      <ul className="pagination pagination-sm mb-0">
        <li className={`page-item ${currentPage === 1 ? "disabled" : ""}`}>
          <button
            className="page-link"
            disabled={currentPage === 1}
            onClick={() => onPageChange(currentPage - 1)}
          >
            {isEnroll ? "Previous" : <i className="bi bi-chevron-left" />}
          </button>
        </li>

        {getVisiblePages().map((page, i) => (
          <li
            key={i}
            className={`page-item ${
              page === "..."
                ? "disabled"
                : page === currentPage
                ? "active"
                : ""
            }`}
          >
            {page === "..." ? (
              <span className="page-link">...</span>
            ) : (
              <button
                className="page-link"
                onClick={() => onPageChange(page)}
              >
                {page}
              </button>
            )}
          </li>
        ))}

        <li className={`page-item ${currentPage === lastPage ? "disabled" : ""}`}>
          <button
            className="page-link"
            disabled={currentPage === lastPage}
            onClick={() => onPageChange(currentPage + 1)}
          >
            {isEnroll ? "Next" : <i className="bi bi-chevron-right" />}
          </button>
        </li>
      </ul>
    </nav>
  )
}